import React, { useCallback } from 'react';

import { useSyncContext } from '@futrli/predict';

import { SyncResultBanner } from './sync-result-banner';
import { useSyncResultEffect } from './hooks/use-sync-result-effect';

import styles from './notifications.scss';

export const SyncResultBannerContainer = () => {
  const { openDrawer, syncResultType, setSyncResultType } = useSyncContext();
  useSyncResultEffect(setSyncResultType);

  const handleClose = useCallback(() => {
    setSyncResultType(null);
  }, [setSyncResultType]);

  if (!syncResultType) {
    return null;
  }

  return (
    <div className={styles.syncResultBanner} role="complementary">
      <SyncResultBanner type={syncResultType} onViewDetails={openDrawer} onClose={handleClose} />
    </div>
  );
};
